import { NgModule } from '@angular/core';

import { HomeComponent } from './components/home.component';
import { HeaderComponent } from 'src/projects/header-footer/src/app/components/header/header.component';
import { HeaderModule } from 'src/projects/header-footer/src/app/modules/header.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { IntroductionComponent } from './components/introduction/introduction.component';
import { ContactUsComponent } from './components/contact-us/contact-us.component';
import { AboutProjectComponent } from './components/about-project/about-project.component';
import { IsdbComponent } from './components/isdb/isdb.component';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { NewsSharedModule } from 'src/shared/news/modules/news-shared.module';
import { QuickLinksComponent } from './components/quick-links/quick-links.component';
import { SharepointModule } from 'src/core/sharepoint/modules/sharepoint.module';
import { NewsHomeComponent } from './components/news-home/news-home.component';
import { OwlModule } from 'ngx-owl-carousel';
import { LoaderModule } from 'src/core/components/loader/modules/loader.module';
import { LoaderComponent } from 'src/core/components/loader/loader.component';
import { HeaderMenuModule } from 'src/projects/header-footer/src/app/modules/header-menu.module';
import { HeaderMenuComponent } from 'src/projects/header-footer/src/app/components/header-menu/header-menu.component';
import { NewsLetterModule } from 'src/shared/news-letter/modules/news-letter.module';

@NgModule({
  declarations: [
   
  HomeComponent,
   
  IntroductionComponent,
   
  ContactUsComponent,
   
  AboutProjectComponent,
   
  IsdbComponent , 

  NewsHomeComponent ,

  QuickLinksComponent
],
  imports: [
    HeaderModule,
    HeaderMenuModule,
    CarouselModule ,
    OwlModule,
    BrowserAnimationsModule,
    NewsSharedModule,
    SharepointModule,
    LoaderModule,
    NewsLetterModule

  ],
  providers:[
  ], 
  bootstrap: [
    HomeComponent,
    HeaderComponent,
    HeaderMenuComponent,
    LoaderComponent
  ]

})
export class HomeModule {
  
 }
